import { useCallback, useRef } from "react";
import styled from "@emotion/styled";
import { useSearchParams } from "react-router-dom";
import { Typography } from "@avenue-8/sidekick-ui";
import { usePageNavbar } from "@shared/components/usePageNavbar";
import { withMainLayout } from "@shared/layouts/withMainLayout";
import { ContactsLayout } from "@features/Contacts/layouts/ContactsLayout";
import { ProfileReviewList } from "@features/Contacts/components/ProfileReview/ProfileReviewList";

const Column = styled.div`
  max-width: 56rem;
  margin: 0 auto;
`;

const Intro = styled(Typography)`
  margin-bottom: 1.5rem;
`;

function ProfileReviewPageContent() {
  const pageRef = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedPage = Number(searchParams.get("page"));
  const page =
    Number.isInteger(requestedPage) && requestedPage > 0 ? requestedPage : 1;

  const handleChangePage = useCallback(
    (nextPage: number) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("page", String(nextPage));
          return next;
        },
        { replace: true },
      );
      pageRef.current?.scrollIntoView({ behavior: "instant" });
    },
    [setSearchParams],
  );

  const header = usePageNavbar({
    title: "Profile Review",
    showBackButton: true,
    backTo: "/contacts",
  });

  return (
    <ContactsLayout header={header}>
      <Column ref={pageRef}>
        <Intro>
          Radar found these possible social profiles for your monitored
          contacts. Confirm the ones that match so Radar can follow their
          activity.
        </Intro>
        <ProfileReviewList page={page} onChangePage={handleChangePage} />
      </Column>
    </ContactsLayout>
  );
}

export const ProfileReviewPage = withMainLayout(ProfileReviewPageContent);
